import getCompany from "./getCompany";

const isCod = () => {
  try {
    const company = getCompany();

    if (company.value !== -1) {
      if (company.selected.data.includes("cod")) {
        return true;
      }
    }

    return false;
  } catch (error) {
    return false;
  }
};

export default isCod;
